import React from 'react'
import './css/Main.css';
export const Card2 = () => {
    return (
        <>
            <div>
                <div className=" bg-black text-white w-full height-full border border-blue-500">
                    <h1 className="text-5xl text-yellow-500 font-semibold px-10 pt-8">How LLM &amp; RAG Works</h1>
                    <section>
                        <p className="text-xl font-light px-10 pt-3">
                            At Iria Research, we build private AI systems tailored to your data. Our LLM fine-tuning process trains models on your domain-specific knowledge, ensuring responses are accurate, secure, and aligned with your business context.
                        </p>
                    </section>
                    <div className="mt-10">
                        <label className="text-5xl text-yellow-500 font-bold pl-10 pt-8">RAG PIPELINE.</label><label className="pt-8 text-5xl text-white font-bold"> Retrieval + Generation</label>
                        <p className="text-xl font-light px-10 pt-3">
                            Retrieval-Augmented Generation (RAG) connects your private knowledge base with a language model in real time. When a query arrives, our system retrieves the most relevant documents and feeds them into the model — delivering factual, up-to-date answers grounded in your own data. No hallucinations. No data leakage.
                        </p>
                        <p className="text-xl font-light px-10 pt-7 text-yellow-400">Secure. Private. Enterprise-ready.</p>
                    </div>
                </div>
            </div>
        </>
    )
}
